<template>
  <div class="brands-page-container">
    <!-- 1. Hero Section -->
    <header class="hero-section" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="hero-overlay">
        <h1 class="hero-headline">Event Production Brands</h1>
        <p class="hero-subheadline">The Architects of Tulum's Scene </p>
      </div>
    </header>

    <div class="brand-page-content">
      <!-- Intro Section -->
      <section class="intro-section">

        <hr class="section-divider">


        <p>
          Tulum is one of the hottest places for <b>Techno and House Music in the world</b>. The most important, popular, and exclusive event production brands from around the globe have a solid stance on the coasts of the Riviera Maya. High-quality production brands are an <b>essential</b> piece of the party landscape, keeping the energy alive in and around Tulum.
        </p>
        <hr class="section-divider">

        <mini-carrousel :photos="brands.map(brand => brand.metadata.main_image.imgix_url)"></mini-carrousel>
        <p>Top Production Brands Keeping The Party Alive</p>

        <hr class="section-divider">

      </section>

      <!-- Brands Grid -->
      <div class="cards-grid">
        <div
          v-for="brand in brands"
          :key="brand.slug"
          class="brand-card"
          v-if="brandConfig[brand.slug]"
        >
          <router-link :to="{ path: '/brands/' + brand.slug }" class="card-link">
            <div class="card-image-container">
              <ResponsiveImage :image="brand.metadata.main_image.imgix_url" :alt="brand.title" class="card-image"/>
              <div class="card-image-overlay">
                <h2 class="card-name">{{ brand.title }}</h2>
                <p class="card-legend">{{ brandConfig[brand.slug].legend }}</p>
              </div>
            </div>
          </router-link>
          <div class="card-content">
            <h3 class="upcoming-title">Upcoming Events</h3>
            <div v-if="getBrandEvents(brand.slug).length > 0" class="upcoming-events-list">
              <MiniEventCard
                v-for="event in getBrandEvents(brand.slug).slice(0, 3)"
                :key="event.slug"
                :event="event"
                withVenue="true"
                withoutBrand="true"
              />
            </div>
            <div v-else class="no-events">
              <p>No upcoming events announced. Check back soon!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import brandsConfig from '../../common/brandsConfig';
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';
import MiniEventCard from '@/components/EventCard/MiniEventCard';
import MiniCarrousel from '@/components/MiniCarrousel';

export default {
  name: 'Brands',
  components: {
    MiniCarrousel,
    ResponsiveImage,
    MiniEventCard,
  },
  metaInfo() {
    return {
      title: `Tulum Event Production Brands | Afterlife, Zamna, Circoloco & More`,
      meta: [
        { name: 'description', content: `Discover the top event production brands that shape Tulum's nightlife, from massive festivals like Zamna and Afterlife to iconic parties like Circoloco and Day Zero.` },
        { name: 'keywords', content: `Tulum Event Production, Tulum Brands, Zamna, Afterlife, Circoloco, Day Zero, SET Underground, Keinemusik` },
      ],
    };
  },
  data() {
    return {
      heroImage: 'https://imgix.cosmicjs.com/14322b50-1301-11ec-b1d5-4d3fd4454d55-image.png',
      brandConfig: brandsConfig,
    };
  },
  computed: {
    ...mapState({
      brands: state => state.brands.sort((a, b) => a.title.localeCompare(b.title)),
      incomingParties: state => state.calendar,
    }),
  },
  created() {
    this.$store.dispatch('getBrands');
    // Ensure the calendar/parties are fetched if not already present

      this.$store.dispatch('getBrandsParties');
  },
  methods: {
    getBrandEvents(brandSlug) {
      if (!this.incomingParties) return [];
      // Normalize slug for matching
      const matchSlug = brandSlug.replace(/-tulum$/, '').replace(/-global$/, '');
      return this.incomingParties.filter(party => party.slug.includes(matchSlug));
    },
  },
};
</script>
